import React, { createContext, useContext, useState, useEffect } from "react";
import { toast } from "react-toastify";
import { fetchDocRequiredTableAndFilterSchema } from "model/DocRequiredModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const DocRequiredContext = createContext();

export const DocRequiredProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [docRequiredContextData, setDocRequiredContextData] = useState();

  const fetchDocRequiredContextData = async () => {
    setLoading(true);
    try {
      const response = await fetchMetadataSchema("metadata:docRequired", () =>
        fetchDocRequiredTableAndFilterSchema([])
      );
      if (response?.success) {
        setDocRequiredContextData(response?.data);
      }
    } catch (err) {
      setError(err);
      toast.error(err?.message || "Failed to load doc required metadata");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchAll = async () => {
      await Promise.all([]);
    };
    fetchAll();
  }, []);

  return (
    <DocRequiredContext.Provider
      value={{ fetchDocRequiredContextData, docRequiredContextData, loading, error }}
    >
      {children}
    </DocRequiredContext.Provider>
  );
};

export const useDocRequiredContext = () => useContext(DocRequiredContext);
